import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  ADVANCE_CONFIRM_MESSAGE,
  ADVANCE_CONFIRM_PARTNAMES,
  ADVANCE_CONFIRM_TITLE,
} from "./advanceConfig";

const CLOSED_STATE = { open: false, itemIndex: null, pendingPartname: "" };

/**
 * Manages the confirmation step for Advance products.
 * - interceptSelection(index, partname): returns true if the selection was held for confirmation
 * - getAutocompleteKey(index): key that remounts a row's Autocomplete after a cancel,
 *   clearing its lingering visual selection
 * - dialogProps: spread onto <AdvanceConfirmDialog />
 */
export const useAdvanceConfirm = (onConfirm) => {
  const [dialogState, setDialogState] = useState(CLOSED_STATE);
  const [resetKeys, setResetKeys] = useState({});

  const interceptSelection = (itemIndex, partname) => {
    if (!ADVANCE_CONFIRM_PARTNAMES.includes(partname)) return false;
    setDialogState({ open: true, itemIndex, pendingPartname: partname });
    return true;
  };

  const handleCancel = () => {
    const { itemIndex } = dialogState;
    setResetKeys((prev) => ({ ...prev, [itemIndex]: (prev[itemIndex] || 0) + 1 }));
    setDialogState(CLOSED_STATE);
  };

  const handleConfirm = () => {
    onConfirm(dialogState.itemIndex, dialogState.pendingPartname);
    setDialogState(CLOSED_STATE);
  };

  return {
    interceptSelection,
    getAutocompleteKey: (index) => `product-autocomplete-${index}-${resetKeys[index] || 0}`,
    dialogProps: { open: dialogState.open, onCancel: handleCancel, onConfirm: handleConfirm },
  };
};

const AdvanceConfirmDialog = ({ open, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ pb: 1, backgroundColor: "#fff3e0", color: "#e65100" }}>
      <Typography variant="h6" sx={{ fontWeight: 600, textAlign: "left" }} dir="rtl">
        {ADVANCE_CONFIRM_TITLE}
      </Typography>
    </DialogTitle>
    <DialogContent sx={{ py: 4 }} dir="rtl">
      <Typography variant="body1" sx={{ textAlign: "left", mt: 3 }}>
        {ADVANCE_CONFIRM_MESSAGE}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2, justifyContent: "space-between" }}>
      <Button onClick={onCancel} variant="contained" color="primary">
        ביטול
      </Button>
      <Button onClick={onConfirm} variant="contained" color="primary">
        אישור
      </Button>
    </DialogActions>
  </Dialog>
);

export default AdvanceConfirmDialog;
